import {useSyncExternalStore} from 'react';
import {message} from './errors.mjs';
// The shared language switch writes <html lang>. Agent Control may also render
// outside the Operations shell: do not require a second locale provider there.
const currentLocale=()=>typeof document==='undefined'?'en':document.documentElement.lang.toLowerCase().split('-')[0]||'en';
function subscribeLocale(notify:()=>void){
 if(typeof document==='undefined'||typeof MutationObserver==='undefined')return ()=>{};
 const observer=new MutationObserver(notify);
 observer.observe(document.documentElement,{attributes:true,attributeFilter:['lang']});
 return ()=>observer.disconnect();
}
export function AgentError({code}:{code:string}){
 const locale=useSyncExternalStore(subscribeLocale,currentLocale,()=> 'en');const label=message(code,locale);
 return <><span>{label}</span>{label!==code&&<details><summary>{locale==='tr'?'Teknik hata kodu':locale==='de'?'Technischer Fehlercode':'Technical error code'}</summary><code>{code}</code></details>}</>;
}
